/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringendsaspect6Inputs */



/**

* @param {_Filter_Class_Stringendsaspect6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringendsaspect6 = /** @type {((inputs?: _Filter_Class_Stringendsaspect6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringendsaspect6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("endet mit")
});
export { _filter_class_stringendsaspect6 as "_filter_class_StringENDSAspect" }